import { EmptyTablePlaceholder } from '@openx/components-core/lib/TablePlaceholder/EmptyTablePlaceholder.tsx';
import { Table, TableName } from '@openx/components-table/Table.tsx';
import type { Account } from '@openx/types/account.ts';
import type { AllTableCriteria, ChangeCriteriaHandler, CriteriaDimension } from '@openx/types/tableCriteria.ts';
import type { UserList } from '@openx/types/user.ts';

import type { UsersListFilters } from '../../types.ts';
import { useAdministrationContext } from '../utils/context/AdministrationContext.tsx';

import { UsersTopBar } from './UsersTopBar.tsx';

type Props = {
  criteria: AllTableCriteria;
  handleCriteriaChange: ChangeCriteriaHandler<CriteriaDimension>;
  handleFiltersChange: (filters: { dimension: typeof CriteriaDimension.FILTERS; value: UsersListFilters }) => void;
  loading: boolean;
  users: UserList[];
};
export const UsersList = ({ criteria, loading, users, handleCriteriaChange, handleFiltersChange }: Props) => {
  const { useGetUsersTableData, useAccountOptionsFetch } = useAdministrationContext();
  const { accounts } = useAccountOptionsFetch();

  const { columns, filtersConfig, rowActions } = useGetUsersTableData(
    accounts.list as Account[],
    (criteria.filters as UsersListFilters).phrase ?? ''
  );

  const isTableEmpty = !loading && !criteria.filters && users.length === 0;

  return (
    <>
      <UsersTopBar
        filtersConfig={filtersConfig}
        filters={criteria.filters as UsersListFilters}
        onChange={handleFiltersChange}
      />

      {isTableEmpty ? (
        <EmptyTablePlaceholder />
      ) : (
        <Table
          name={TableName.USERS}
          data={users}
          columns={columns}
          criteria={criteria}
          loading={loading}
          onCriteriaChange={handleCriteriaChange}
          rowActions={rowActions}
        />
      )}
    </>
  );
};
